import App from './App.svelte';
import "the-new-css-reset/css/reset.css";

const app = new App({
  target: document.body
});

export default app;